// source: mti/store/secure_plug/secure_plug_port_status.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

goog.exportSymbol('proto.mti.store.secure_plug.SecurePlugPortStatus', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mti.store.secure_plug.SecurePlugPortStatus = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.mti.store.secure_plug.SecurePlugPortStatus, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mti.store.secure_plug.SecurePlugPortStatus.displayName = 'proto.mti.store.secure_plug.SecurePlugPortStatus';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mti.store.secure_plug.SecurePlugPortStatus.prototype.toObject = function(opt_includeInstance) {
  return proto.mti.store.secure_plug.SecurePlugPortStatus.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mti.store.secure_plug.SecurePlugPortStatus} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mti.store.secure_plug.SecurePlugPortStatus.toObject = function(includeInstance, msg) {
  var f, obj = {
    devicePluggedIn: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    calibrated: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    calibrationFailed: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    socketFault: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    socketDeviceType: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mti.store.secure_plug.SecurePlugPortStatus}
 */
proto.mti.store.secure_plug.SecurePlugPortStatus.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mti.store.secure_plug.SecurePlugPortStatus;
  return proto.mti.store.secure_plug.SecurePlugPortStatus.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mti.store.secure_plug.SecurePlugPortStatus} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mti.store.secure_plug.SecurePlugPortStatus}
 */
proto.mti.store.secure_plug.SecurePlugPortStatus.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDevicePluggedIn(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCalibrated(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCalibrationFailed(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSocketFault(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setSocketDeviceType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mti.store.secure_plug.SecurePlugPortStatus.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mti.store.secure_plug.SecurePlugPortStatus.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mti.store.secure_plug.SecurePlugPortStatus} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mti.store.secure_plug.SecurePlugPortStatus.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDevicePluggedIn();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getCalibrated();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getCalibrationFailed();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getSocketFault();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getSocketDeviceType();
  if (f !== 0) {
    writer.writeUint32(
      5,
      f
    );
  }
};


/**
 * optional bool device_plugged_in = 1;
 * @return {boolean}
 */
proto.mti.store.secure_plug.SecurePlugPortStatus.prototype.getDevicePluggedIn = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.mti.store.secure_plug.SecurePlugPortStatus} returns this
 */
proto.mti.store.secure_plug.SecurePlugPortStatus.prototype.setDevicePluggedIn = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional bool calibrated = 2;
 * @return {boolean}
 */
proto.mti.store.secure_plug.SecurePlugPortStatus.prototype.getCalibrated = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.mti.store.secure_plug.SecurePlugPortStatus} returns this
 */
proto.mti.store.secure_plug.SecurePlugPortStatus.prototype.setCalibrated = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional bool calibration_failed = 3;
 * @return {boolean}
 */
proto.mti.store.secure_plug.SecurePlugPortStatus.prototype.getCalibrationFailed = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.mti.store.secure_plug.SecurePlugPortStatus} returns this
 */
proto.mti.store.secure_plug.SecurePlugPortStatus.prototype.setCalibrationFailed = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional bool socket_fault = 4;
 * @return {boolean}
 */
proto.mti.store.secure_plug.SecurePlugPortStatus.prototype.getSocketFault = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.mti.store.secure_plug.SecurePlugPortStatus} returns this
 */
proto.mti.store.secure_plug.SecurePlugPortStatus.prototype.setSocketFault = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional uint32 socket_device_type = 5;
 * @return {number}
 */
proto.mti.store.secure_plug.SecurePlugPortStatus.prototype.getSocketDeviceType = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.mti.store.secure_plug.SecurePlugPortStatus} returns this
 */
proto.mti.store.secure_plug.SecurePlugPortStatus.prototype.setSocketDeviceType = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


goog.object.extend(exports, proto.mti.store.secure_plug);
